import "./../css/sass/styles.scss";

import './components/style-video.ce';
import {gsap} from "./Utility/gsap";
import {InitializeIntroAnimation} from "./components/intro-animation";
import { InitializeGSAPOnPageLoad} from './Utility/init-gsap';
import { observeElementResize, documentReady } from "./Utility/utils";
import {InitializeSliders} from "./components/slider";
import {InitializeCopyGridSliders} from "./components/copy-grid";
import {InitiateHomepageHero} from "./components/homepage-hero";
import {listenForMediaLoad} from "./components/video";
import {InitModalBlock} from "./components/modal";
import {InitDocumentation} from "./components/documentation";
import {InitAOSForms, InitializeContactForms} from "./components/contact-forms";
import {InitializeNav} from "./components/nav";
import {InitializeHoverLists} from "./components/media-list-hover-effect";
import {InitializeDataCounters} from "./components/data-counter";
import {InitializePostListing} from "./components/post-listing-filter";
import ParallaxGridBlock from "./components/parallax-grid-block";
import ThemeChanger from "./Utility/theme-changer";
import PreloadImages from "./Utility/image-loader";
import PV from "./Utility/petite-vue";
import CalculateGridSize from "./Utility/grid-sizer";
import { InitializeAnimatedIllustrations } from "./components/animated-illustrations";
import { InitializePeopleIconRotator } from "./components/people-icon-rotator";
import { initLazyLoad, updateLazyLoad, loadAllAssets } from "./Utility/lazy-loading";
import { InitMediaBlocks } from "./components/media-block";
import { InitResultsCardCarousels } from "./components/results-card";


const InitializePeopleList = () => {
  //people list grid sizer
  const pls = document.querySelectorAll('.people-list')
  pls.forEach( pl => {

    const peopleListResizeHandler = () => {
        CalculateGridSize(pl, '--row-count');
    };
    peopleListResizeHandler();
    observeElementResize(pl, peopleListResizeHandler);

  });
 
}

const InitializeClientGrid = () => {
  const cgs = document.querySelectorAll('.client-grid')
  cgs.forEach( cg => {

    const clientGridResizeHandler = () => {
        CalculateGridSize(cg);
    };
    clientGridResizeHandler();
    observeElementResize(cg, clientGridResizeHandler);

  });
}

const InitializeBackgroundImage = () => {
  //if there was a background image before, get rid of it
  const oldBgImage = document.querySelector('body > .page-background-image')
  if( oldBgImage ) {

    gsap.to( oldBgImage, {
      autoAlpha: 0,
      duration: 1,
      onComplete: () => {
        oldBgImage.parentNode.removeChild(oldBgImage);
      }
    })
  }

  //If there's a new background image, move it into the body and fade it in.
  const bgImage = document.querySelector('.site-main > .page-background-image');

  if( bgImage ) {
    const colorChanger = document.querySelector('body > canvas.background');
    gsap.from( bgImage, {
      autoAlpha: 0,
      duration: 1
    })
    colorChanger.after(bgImage);
  }
}


// Used for when adding .inline-arrow-btn class
// This will add the arrow icon so it's easy to add the button from the editor.
const addInlineArrowButtonIcon = () => {
  const els = document.querySelectorAll('.inline-arrow-btn');

  if(els){
    els.forEach(el => {
      const arrowEl = document.createElement("div");
      arrowEl.classList.add('arrow-btn');
      el.appendChild(arrowEl);
    });
  }
}


const FadeOutSiteCurtain = () => {
  // If the site cutrain is visible, fade it out.
  const curtain = document.querySelector('.siteCurtain');
  if(!curtain.classList.contains('curtain-hidden')){
    curtain.classList.add('curtain-hidden');
  }
}


const InitializeGoogleAnalytics = () => {
  var path = document.location.pathname + document.location.search + document.location.hash;
  
  // only send pageviews from production URL
  if(document.location.host == 'wearetraina.com' || document.location.host == 'molequlbrands.com'){
    gtag('event', 'page_view', {
      page_title: document.title,
      page_location: document.location.href,
      page_path: path,
    });
  }
}




documentReady(() => {
  PV.mount('body');
  PV.store.InitialLoad = true;
  PV.store.ThemeChanger = new ThemeChanger();
  PV.store.Liquifiers = [];

  InitializeNav();
  InitializeGSAPOnPageLoad();
  InitializePostListing();
  initLazyLoad();

  // InitializeGoogleAnalytics();
  InitializeIntroAnimation();

  PV.store.ThemeChanger.observeThemeChangers();

  InitializeClientGrid();

  InitializeBackgroundImage();

  listenForMediaLoad();

  InitMediaBlocks();

  InitResultsCardCarousels();

  FadeOutSiteCurtain();

  //people list grid sizer
  setTimeout( () => {

    requestAnimationFrame( () => {
      PreloadImages();
      InitializeAnimatedIllustrations();
      InitializePeopleList();
      InitializeHoverLists();
      InitializeSliders();
      InitializeCopyGridSliders();
      InitiateHomepageHero();
      InitializeContactForms();
      InitAOSForms();
      InitModalBlock();
      InitDocumentation();
      InitializePeopleIconRotator();
      addInlineArrowButtonIcon();
      updateLazyLoad();
      ParallaxGridBlock();
    });

  }, 500);

  // Give the page plenty of time to load on it's own, but after 
  // a significant wait, load in all lazy loaded content
  // This helps avoid seeing loading animations waiting for images/videos
  // to load well after the page has finished loading. 
  setTimeout(() => {
    loadAllAssets();
  }, 10000);
});

